import { FC } from "react";

import { GamePlanTimePeriod } from "@ctra/api";
import { Enterprise as Copy, useTranslation } from "@ctra/i18n";
import { DAY, Epoch, FORTNIGHT } from "@ctra/utils";
import { ClockCircleOutlined, Typography } from "@ctra/components";

const { Text } = Typography;

/**
 * Game plan deadline component
 * @param startEpoch
 * @param endEpoch
 * @constructor
 */
export const Deadline: FC<GamePlanTimePeriod> = ({ startEpoch, endEpoch }) => {
  const { t } = useTranslation();

  /**
   * The number of days until the deadline
   */
  const daysUntilDeadline = Epoch.daysBetween(Epoch.now(), endEpoch);

  /**
   * Tell if the game plan is past
   */
  const ended = daysUntilDeadline <= 0;

  /**
   * The game plan ends when there is less than 2 weeks left
   */
  const endingSoon = !ended && daysUntilDeadline * DAY < FORTNIGHT;

  /**
   * Render a localised date from the given epoch
   * @param epoch
   */
  const renderDate = (epoch: number) => {
    return Epoch.asMoment(epoch).format("L");
  };

  return (
    <Text type={endingSoon ? "danger" : "secondary"}>
      {ended ? (
        <>
          {renderDate(startEpoch)} - {renderDate(endEpoch)}
        </>
      ) : (
        <>
          <ClockCircleOutlined />{" "}
          {t<string>(Copy.gamePlan.labels.deadline, {
            timeUntil: Epoch.until(endEpoch)
          })}
        </>
      )}
    </Text>
  );
};
